import { LTUtils } from "../../LTGame/LTUtils/LTUtils";
import Vector3Ex from "../../LTGame/LTUtils/Vector3Ex";
import LTPlatform from "../../LTGame/Platform/LTPlatform";
import LTRes from "../../LTGame/Res/LTRes";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import LTUI from "../../LTGame/UIExt/LTUI";
import UI_Store from "../../ui/Main/UI_Store";
import GameData from "../common/GameData";
import GlobalUnit from "../common/GlobalUnit";
import ResDefine from "../common/ResDefine";
import { StoreConfig } from "../config/StoreConfig";
import { UI_MainMediator } from "./UI_MainMediator";
export class UI_StoreMediator extends BaseUIMediator {
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_StoreMediator();
            this._instance._classDefine = UI_Store;
        }
        return this._instance;
    }
    _OnShow() {
        const _super = Object.create(null, {
            _OnShow: { get: () => super._OnShow }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super._OnShow.call(this);
            this._openParam = 1;
            GlobalUnit.game.camera.TurnOff();
            LTPlatform.instance.HideBannerAd();
            this.ui.m_btn_change.onClick(this, this.ClickChange);
            this.ui.m_btn_close.onClick(this, this.Hide);
            this.ui.m_list.setVirtual();
            this.ui.m_list.itemRenderer = Laya.Handler.create(this, this.RenderItem, null, false);
            this.ui.m_list.on(fairygui.Events.CLICK_ITEM, this, this.ClickItem);
            this.ui.m_list.refreshVirtualList();
            this.ui.m_btn_tag_1.onClick(this, this.ClickTag, [1]);
            this.ui.m_btn_tag_2.onClick(this, this.ClickTag, [2]);
            this.ChangeStoreDate();
            // this.RefreshUI();
            yield this._createCamera();
        });
    }
    ClickTag(num) {
        LTUtils.Vibrate(false);
        this._openParam = num;
        this.ChangeStoreDate();
        if (num == 2 && GameData.instance.skinRed) {
            GameData.instance.skinRed = false;
            GameData.SaveToDisk();
        }
    }
    ChangeStoreDate() {
        this.selectedIndex = null;
        this.storeData = StoreConfig.dataList.filter(e => e.item_type == this._openParam).sort((a, b) => a.sort_order - b.sort_order);
        this.RefreshTagUI();
        this.RefreshUI();
    }
    RefreshTagUI() {
        this.ui.m_btn_tag_1.m_clicked.selectedIndex = this._openParam == 1 ? 0 : 1;
        this.ui.m_btn_tag_2.m_clicked.selectedIndex = this._openParam == 1 ? 1 : 0;
        this.ui.m_btn_tag_1.m_tag.selectedIndex = 0;
        this.ui.m_btn_tag_2.m_tag.selectedIndex = 1;
        this.ui.m_btn_tag_2.m_red.visible = GameData.instance.skinRed;
    }
    RefreshUI() {
        this.ui.m_list.numItems = this.storeData.length;
        this.ui.m_com_coin.m_text_count.text = GameData.instance.coinCount.toString();
        this.RefreshChangeBtnUI();
    }
    ClickChange() {
        return __awaiter(this, void 0, void 0, function* () {
            let config = this.storeData[this.selectedIndex];
            switch (this.ui.m_btn_change.m_change_type.selectedIndex) {
                case 0:
                    GlobalUnit.dataManager.UseItem(config.item_type, config.item_value);
                    this.RefreshUI();
                    break;
                case 1:
                    GlobalUnit.dataManager.UseItem(config.item_type, 0);
                    this.RefreshUI();
                    break;
                case 2:
                    GameData.instance.coinCount -= config.unlock_value;
                    GlobalUnit.dataManager.UnlockItem(config.item_type, config.item_value);
                    this.RefreshUI();
                    break;
                case 3:
                    let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
                    if (res) {
                        LTPlatform.instance.RecordEvent('game_ad', { level_id: GlobalUnit.game.level.config.id, id: 'shop_' + config.id });
                        let num = GlobalUnit.dataManager.UpdateProgress(config.id);
                        if (num >= config.unlock_value) {
                            GlobalUnit.dataManager.UnlockItem(config.item_type, config.item_value);
                        }
                        this.RefreshUI();
                    }
                    break;
            }
        });
    }
    RefreshChangeBtnUI() {
        let config = this.storeData[this.selectedIndex];
        let btn = this.ui.m_btn_change;
        btn.visible = !!config;
        btn.enabled = true;
        if (config) {
            let unlock = GlobalUnit.dataManager.CheckItemUnlock(config.item_type, config.item_value);
            if (unlock || config.unlock_type == 0) {
                let isUse = GlobalUnit.dataManager.CheckItemUse(config.item_type, config.item_value);
                btn.visible = isUse && config.item_type == 2 ? false : true;
                btn.m_change_type.selectedIndex = isUse ? 1 : 0;
            }
            else {
                switch (config.unlock_type) {
                    case 1:
                        btn.m_change_type.selectedIndex = 2;
                        btn.m_text_count.text = config.unlock_value.toString();
                        btn.enabled = config.unlock_value < GameData.instance.coinCount;
                        break;
                    case 2:
                        btn.m_change_type.selectedIndex = 3;
                        btn.m_text_count.text = `${GlobalUnit.dataManager.GetStoreProgress(config.id)}/${config.unlock_value}`;
                        break;
                }
            }
        }
    }
    ClickItem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let index = item.data;
            this.selectedIndex = index;
            yield this._loadModel();
            this.RefreshUI();
        });
    }
    RenderItem(index, item) {
        let config = this.storeData[index];
        item.data = index;
        let unlock = config.unlock_type == 0 || GlobalUnit.dataManager.CheckItemUnlock(config.item_type, config.item_value);
        item.m_item_type.selectedIndex = unlock ? 1 : 0;
        item.m_is_select.selectedIndex = (this.selectedIndex == index) ? 1 : 0;
        item.m_img_display.url = config.img_url;
        item.m_img_name.url = unlock ? config.name_unlock : config.name_lock;
    }
    _createCamera() {
        return __awaiter(this, void 0, void 0, function* () {
            let rtt = this._ui.m_img_display;
            rtt.visible = false;
            LTUI.LockScreen();
            this._root = yield LTRes.LoadAndGet(ResDefine.FixScene("ZS"));
            Laya.stage.addChild(this._root);
            this._node = LTUtils.FindChild(this._root, "ZS_01/xuanzhuan/jiaose");
            let camera = LTUtils.FindChild(this._root, "ZS_01/daCamera/Camera");
            // 注意格式只能用r8g8b8a8否则ip6不支持
            this._cacheRt = new Laya.RenderTexture(rtt.width, rtt.height, Laya.RenderTextureFormat.R8G8B8A8, Laya.RenderTextureDepthFormat.DEPTH_16);
            let cacheImage = new fgui.GImage();
            this._ui.addChildAt(cacheImage, this._ui.getChildIndex(rtt) + 1);
            cacheImage.image.texture = new Laya.Texture(this._cacheRt);
            cacheImage.setPivot(rtt.pivotX, rtt.pivotY, rtt.pivotAsAnchor);
            cacheImage.setXY(rtt.x, rtt.y);
            camera.renderTarget = this._cacheRt;
            LTUI.UnlockScreen();
            rtt.visible = true;
        });
    }
    _loadModel() {
        return __awaiter(this, void 0, void 0, function* () {
            LTUI.LockScreen();
            this._node.destroyChildren();
            let node;
            let config;
            config = this.storeData[this.selectedIndex];
            yield LTRes.LoadAsync(ResDefine.FixPath(config.model_path));
            node = LTRes.Get(ResDefine.FixPath(config.model_path));
            if (node) {
                this._node.addChild(node);
                let trs = node.transform;
                let v = Vector3Ex.temp;
                v.setValue(config.offset_pos[0], config.offset_pos[1], config.offset_pos[2]);
                trs.localPosition = v;
                v.setValue(config.offset_scale[0], config.offset_scale[1], config.offset_scale[2]);
                trs.localScale = v;
                v.setValue(config.offset_rot[0], config.offset_rot[1], config.offset_rot[2]);
                trs.localRotationEuler = v;
            }
            LTUI.UnlockScreen();
        });
    }
    _OnHide() {
        return __awaiter(this, void 0, void 0, function* () {
            LTUI.LockScreen();
            GlobalUnit.game.camera.TurnOn();
            if (this._root) {
                this._root.destroy();
                this._root = null;
                LTRes.Unload(ResDefine.FixScene("ZS"));
            }
            if (GlobalUnit.dataManager.tryPetId != GameData.instance.petId) {
                yield GlobalUnit.game.pet.ChangeSkin(GameData.instance.petId);
                GlobalUnit.dataManager.tryPetId = GameData.instance.petId;
            }
            if (GlobalUnit.dataManager.tryRoleId != GameData.instance.roleId) {
                yield GlobalUnit.game.player.ChangeSkin(GameData.instance.roleId);
                GlobalUnit.dataManager.tryRoleId = GameData.instance.roleId;
            }
            UI_MainMediator.instance.RefreshUI();
            LTUI.UnlockScreen();
        });
    }
}
